<template>
    <div v-if="position">
        <position-header :position="position" :from-main="fromMain"></position-header>
        <position-summary :position="position"></position-summary>
        <application-form :position_id="position.id" :position_color="position.departments[0].color">
            <template slot="heading">
                <h1 class="heading--md main-heading text-capitalize text-center" id="apply-now">Apply for this job</h1>
                <p class="paragraph text-center">Don’t forget to include a resume and cover letter. We receive a lot of
                    applications, but
                    we’ll notice a fun, well-written intro that shows us you take play seriously. </p>
                <div class="divider"></div>
                <hr/>
            </template>
        </application-form>
    </div>
</template>

<script>
    import PositionHeader from "../components/positionPageComponents/PositionHeader";
    import PositionSummary from "../components/positionPageComponents/PositionSummary";
    import Hero from "../components/openPositions/Hero";
    import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";
    import {getPosition} from "../services/position";

    export default {
        components: {
            ApplicationForm,
            Hero,
            PositionSummary,
            PositionHeader
        },
        name: "PositionPage",
        metaInfo() {
            return {
                title: this.$route.params.slug,
                htmlAttrs: {
                    lang: 'en',
                    metaInfo: {
                        meta: [
                            {charset: 'utf-8'},
                            {name: 'og:title', content: 'Position page'},
                            {name: 'description', content: 'Bohemia Interactive position page'},

                        ]
                    }

                }

            }
        },
        data() {
            return {
                position: null,
                fromMain:false
            }
        },
        computed: {
            slug() {
                return this.$route.params.slug;

            }
        },
        methods: {
            async fetchPosition(slug) {
                try {
                    const response = await getPosition(slug);
                    this.position = response;
                }
                catch (e) {
                    console.log('error loading featured positions')
                }
            },

        },
        beforeRouteEnter(to, from, next){
            next(vm => {
                console.log(from.name)
                if(from.name === 'join-page' || from.name === null){
                    vm.fromMain = true;
                }
            })
        },
        created() {
            this.fetchPosition(this.slug)


        }
    }
</script>

<style scoped>
    .main-heading {
        text-transform: uppercase;
        font-size: 36px;
        font-weight: 800;
        letter-spacing: 0.72px;
        font-family: Montserrat, sans-serif;
        margin-top: 60px;
    }

    .paragraph {
        font-family: "Inter UI", sans-serif;
        font-size: 16px;
        letter-spacing: 0.02px;
        line-height: 28px;
        font-weight: 400;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PositionPage.vue